import { MoneyBox, NumberBoxLayoutStyle } from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';

export const LoanAmountField = () => {
    const value = useWizardDemoStore((state) => state.applicationKeyItems.loanAmount);
    const updateApplicationKeyItems = useWizardDemoStore((state) => state.updateApplicationKeyItems);

    return (
        <MoneyBox
            id='applicationLoanAmount'
            value={value}
            onChange={(amount) => updateApplicationKeyItems({ loanAmount: amount ?? undefined })}
            label='Loan Amount'
            required={true}
            width={'100%'}
            min={0}
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            height={'36px'}
            labelWidth='180px'
        />
    );
};
